import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CreateEmptyCartMutationObject {
  mutation: {
    createEmptyCart: boolean
  }
}

export const createEmptyCartMutationObject: CreateEmptyCartMutationObject = {
  mutation: {
    createEmptyCart: true
  }
}

export type GetCreateEmptyCartMutation = () => Promise<FetchResult<any>>

export const createEmptyCartMutation = ({ getMutations }: ServiceDependencies): GetCreateEmptyCartMutation => async () => {
  const mutation = getMutations().createEmptyCartMutation

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
